export default {
  overview: {
    logo: "${webTitle}",
    billing: {
      header: '账单',
      availableCredit: '账户余额',
      consumptionTip: '本月累计消费',
      addFunds: '充值'
    },
    products: {
      header: '产品',
      ecc: {header: '云服务器 (ECC)', introduction: '高可用虚拟服务器。'},
      bms: {
        header: '裸金属服务器（BMS）',
        introduction: '弹性裸金属计算服务。'
      },
      mysql: {
        header: 'MySQL 数据库(RDS)',
        introduction: '高稳定、高性能的MySQL云数据库。'
      },
    },
    support: {
      header: '支持',
      guide: '指南和教程',
      faq: '常见问题',
      contact: '联系我们'
    },
    rechargeDialog: {

    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/overview.js